import { render } from "./CompanyInformation.vue?vue&type=template&id=de5a0e26"
import script from "./CompanyInformation.vue?vue&type=script&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SetUp/Company/CompanyInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de5a0e26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de5a0e26', __exports__)) {
    api.reload('de5a0e26', __exports__)
  }
  
  module.hot.accept("./CompanyInformation.vue?vue&type=template&id=de5a0e26", () => {
    api.rerender('de5a0e26', render)
  })

}


export default __exports__